module.exports = __webpack_public_path__ + "static/media/lightBlueQuestionMark.13fd589c.svg";